import React, {Component} from 'react';
import { connect } from "react-redux"
import {stripeErrors} from '../../utils/errors'
import {CardElement, CardNumberElement, CardExpiryElement, CardCVCElement, injectStripe} from 'react-stripe-elements';
import { pushToDataLayer } from '../Analytics'

class PaymentForm extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            loading: false,
            disabled: false
        }
    }

    async submit(ev) {
        const { dispatchStripeError, dispatchGenerateToken, dispatchSetToken } = this.props;
        let {token, error} = await this.props.stripe.createToken({name: "Name"});
        if(error){
            dispatchGenerateToken(false);
            dispatchStripeError(stripeErrors[error.code])
            return false;
        }
        
        dispatchStripeError('')
        dispatchSetToken(token)

        pushToDataLayer('addtocart_junior', 'Cart', 'AddToCart', 'Junior')
    }
    
    render() {
        const { generateToken, dispatchGenerateToken } = this.props;

        if(generateToken){
            dispatchGenerateToken(false);
            this.submit()
        }

        const stripeStyle = {
            base: {
                fontSize: '16px',
                color: '#424770',
                letterSpacing: '0.025em',
                '::placeholder': {
                    color: '#aab7c4',
                },
            },
            invalid: {
                color: '#c23d4b'
            }
        };

        return (
            <div className="checkout">
                <div className='accountFormEmail'>
                    <h4>Kortnummer</h4>
                    <CardNumberElement className="form-control"
                        onChange={this.handleChange}
                        style={stripeStyle}
                    />
                </div>

                <div className='accountFormEmail'>
                    <h4>MM/YY</h4>
                    <CardExpiryElement  className="form-control w-50"
                        onChange={this.handleChange}
                        style={stripeStyle}
                        placeholder="MM/YY"
                    />
                </div>

                <div className='accountFormEmail'>
                    <h4>CVC</h4>
                    <CardCVCElement className="form-control w-50 last-w"
                        onChange={this.handleChange}
                        style={stripeStyle}
                        placeholder="XXX"
                    />
                </div>
            </div>
        );
    }
}

const reduxProps = (state) => {
    return {
        submit: state.juniorFormSubmit,
        stripeError: state.juniorStripeError,
        generateToken: state.juniorGenerateToken,
    }
}
  
const dispatchToProps = dispatch => {
    return { 
        dispatchSetToken: (token) => dispatch({ type: `JUNIOR_TOKEN`, value: token }),
        dispatchStripeError: (error) => dispatch({ type: `JUNIOR_STRIPE_ERROR`, value: error }),
        dispatchGenerateToken: (status) => dispatch({ type: `JUNIOR_GENERATE_TOKEN`, value: status }),
    }
}

export default connect(reduxProps, dispatchToProps)(injectStripe(PaymentForm));